module.exports = __webpack_public_path__ + "img/T6-B-7.717b70b5.png";